export const PAGE_VIEW_EVENTS_CATEGORY = "PageView";
export const CUSTOM_EVENTS_CATEGORY = "CustomEvent";
